import PropTypes from 'prop-types';
import { WriterlyIcon } from '@shared/Icon/Icon';
import { Box, Typography, useTheme } from '@mui/material';

export const WriterlyAuthLogo = ({ width, height, color, isHorizontal }) => {
  const theme = useTheme();
  return (
    <div className="flex justify-center">
      {isHorizontal ? (
        <Box className={`flex flex-col items-start`}>
          <Box className={`flex items-center gap-4`}>
            <WriterlyIcon
              iconName={'LogoRaw'}
              width={width ?? '100%'}
              height={height ?? '120px'}
              alt="ekom-logo"
              color={color ?? theme.palette.text.primary}
            />

            <Typography
              variant="h4"
              className="text-[55px] leading-10 -tracking-tight"
              sx={{ color: theme.palette.text.primary }}
            >
              EKOM
            </Typography>
          </Box>
        </Box>
      ) : (
        <WriterlyIcon
          iconName={'logo'}
          width={width ?? '100%'}
          height={height ?? '120px'}
          alt="ekom-logo"
          color={color ?? theme.palette.text.primary}
        />
      )}
    </div>
  );
};

WriterlyAuthLogo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};
